import * as shard from '@/counter'
import { db } from "@/firebase";

export const generateUTCDateString = function (date){
    return [(date.getUTCMonth()+1),date.getUTCDate(),date.getUTCFullYear()].join('-')
}

export const createSession = async function(shopId){
    //let sessions = new shard.Counter(db.doc("/shops/" + shopId + "/analytics/default"), "sessions")
    let dailySessions = new shard.Counter(db.doc("/shops/" + shopId + "/analytics/default/days/"+generateUTCDateString(new Date())), "sessions")
    //await sessions.incrementBy(1)
    await dailySessions.incrementBy(1)
}

export const registerClick = async function(shopId){
    //let clicks = new shard.Counter(db.doc("/shops/" + shopId + "/analytics/default"), "clicks")
    let dailyClicks = new shard.Counter(db.doc("/shops/" + shopId + "/analytics/default/days/"+generateUTCDateString(new Date())), "clicks")
    //await clicks.incrementBy(1)
    await dailyClicks.incrementBy(1)
}